export default __webpack_public_path__ + "static/media/ILPlatform_Teacher.33806363.webp";